<template>
  <div>
    <vx-card no-shadow id="login-page-details">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(onClickSubmitForm)"
          autocomplete="off"
          id="login-page-settings"
        >
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="title"
                name="title"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Title</small>
                <vs-input
                  v-model="formData.title"
                  class="w-full required"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider
                vid="tile1"
                name="tile1"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Tile 1</small>
                <vs-input
                  v-model="formData.title_1"
                  class="w-full required"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                />
              </ValidationProvider>
            </div>

            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider
                vid="tile2"
                name="tile2"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Tile 2</small>
                <vs-input
                  v-model="formData.title_2"
                  class="w-full required"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                />
              </ValidationProvider>
            </div>

            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider
                vid="tile3"
                name="tile3"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Tile 3</small>
                <vs-input
                  v-model="formData.title_3"
                  class="w-full required"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="footer_text"
                name="footer_text"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Footer Text</small>
                <vs-input
                  v-model="formData.footer_text"
                  class="w-full required"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="copyright_text"
                name="copyright_text"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Copyright Text</small>
                <vs-input
                  v-model="formData.copyright_text"
                  class="w-full required"
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2"
              >Save Changes</vs-button
            >
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const InProductCommunication = RepositoryFactory.get("inProductCommunication");
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";

export default {
  name: "ManageLoginPage",
  data() {
    return {
      formData: {
        title: "",
        title_1: "",
        title_2: "",
        title_3: "",
        footer_text: "",
        copyright_text: "",
      },
    };
  },
  mixins: [ErrorMessages, SuccessMessage],
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async onClickSubmitForm() {
      console.log("im getting called");
      await this.$vs.loading({
        container: "#login-page-settings",
        scale: 0.5,
      });
      try {
        await InProductCommunication.updateLoginPageSettings(this.formData);
        this.showSuccessMessage("Settings updated successfully");
      } catch (error) {
        console.log("error", error);
        this.convertAndNotifyError(error);
      }
      await this.$vs.loading.close("#login-page-settings > .con-vs-loading");
    },

    async fetchData() {
      await this.$vs.loading({
        container: "#login-page-settings",
        scale: 0.5,
      });

      try {
        const response = (await InProductCommunication.getLoginPageSettings())
          .data.data;

          console.log("response dataset", response)

        if (response) {
          this.formData = {
            title:
              response.title && response.title.elements.length > 0
                ? response.title.elements[0].value
                : "",
            title_1:
              response.title_1 && response.title_1.elements.length > 0
                ? response.title_1.elements[0].value
                : "",
            title_2:
              response.title_2 && response.title_2.elements.length > 0
                ? response.title_2.elements[0].value
                : "",
            title_3:
              response.title_3 && response.title_3.elements.length > 0
                ? response.title_3.elements[0].value
                : "",
            footer_text:
              response.footer_text && response.footer_text.elements.length > 0
                ? response.footer_text.elements[0].value
                : "",
            copyright_text:
              response.copyright_text &&
              response.copyright_text.elements.length > 0
                ? response.copyright_text.elements[0].value
                : "",
          };
        }
      } catch (error) {
        this.convertAndNotifyError(e);
      }

      await this.$vs.loading.close("#login-page-settings > .con-vs-loading");
    },
  },
};
</script>
